import { createMutationHook, useApiQuery } from 'queries/common';

import firehydrantAPI from '../../helpers/firehydrantAPI';

const SERVICES = 'services';
export default function useServices(params = {}, options = {}) {
  const requestParams = {
    params: { ...params, lite: true, include: ['owner', 'active_incidents'] },
  };

  const query = useApiQuery(
    [SERVICES, 'list', params],
    () => firehydrantAPI.get('/services', requestParams),
    options,
  );

  return {
    ...query,
  };
}

export const useService = (id) => {
  const query = useApiQuery(
    [SERVICES, 'detail', id],
    () => firehydrantAPI.get(`/services/${id}`),
    { enabled: !!id },
  );

  return {
    ...query,
    service: query?.data?.data ?? {},
  };
};

export const useServiceShow = (id, incidentParams) => {
  const serviceQuery = useApiQuery(['services', 'detail', id], () =>
    firehydrantAPI.get(`/services/${id}`),
  );

  const activeIncidentsQuery = useApiQuery(
    ['incidents', 'list', { services: id, ...incidentParams }],
    () =>
      firehydrantAPI.get('/incidents', {
        params: { services: id, ...incidentParams },
      }),
    { enabled: !!serviceQuery.data?.data?.id },
  );

  const inactiveIncidentsQuery = useApiQuery(
    ['incidents', 'list', { services: id, active: false, per_page: 5 }],
    () =>
      firehydrantAPI.get('/incidents', {
        params: { services: id, active: false, per_page: 5 },
      }),
    { enabled: !!serviceQuery.data?.data?.id },
  );

  return {
    isLoading:
      serviceQuery.isLoading ||
      activeIncidentsQuery.isLoading ||
      inactiveIncidentsQuery.isLoading,
    error:
      serviceQuery.isError ||
      activeIncidentsQuery.isError ||
      inactiveIncidentsQuery.isError,
    service: serviceQuery.data?.data,
    incidents: activeIncidentsQuery.data?.data?.data,
    inactiveIncidents: inactiveIncidentsQuery.data?.data?.data,
    refetchService: serviceQuery.refetch,
    refetchIncidents: activeIncidentsQuery.refetch,
  };
};

export const useCreateService = (options) =>
  createMutationHook((body) => firehydrantAPI.post('services', body))(options);

export const useUpdateService = (options) =>
  createMutationHook((body) =>
    firehydrantAPI.patch(`/services/${body.id}`, body),
  )(options);

export const useDeleteService = (options) =>
  createMutationHook((id) => firehydrantAPI.delete(`/services/${id}`))(options);
